/**
 * Hunt57 logo component — uses the transparent PNG directly, no wrapper.
 */
export default function Logo({ variant = "nav", className = "", alt = "Hunt57", ...rest }) {
  const src = variant === "hero" ? "/hunt57-logo-hero.png" : "/hunt57-logo-nav.png";
  const heightClass =
    variant === "hero"
      ? "h-28 sm:h-32 md:h-36 lg:h-40"
      : variant === "sm"
      ? "h-9"
      : "h-11 md:h-12";
  return (
    <img
      src={src}
      alt={alt}
      className={`${heightClass} w-auto object-contain ${className}`}
      loading="eager"
      {...rest}
    />
  );
}
